<main class="page-container">
  @if (loadingPage) {
    <app-loading [fullscreen]="true" label="Cargando empresas..."></app-loading>
  }
  <app-page-header
    title="Empresas"
    description="Administra las empresas registradas en la plataforma"
  >
    <app-button type="button" variant="primary" size="large" (clicked)="nuevaEmpresa()">
      <i class="fa-solid fa-plus"></i>
      Nueva empresa
    </app-button>
  </app-page-header>

  <div class="summary-grid">
    <app-summary-card
      label="Empresas activas"
      [value]="infoEmpresas?.empresasActivas?.toString() || null"
      icon="fa-solid fa-building-circle-check"
      tone="green"
    />

    <app-summary-card
      label="Empresas inactivas"
      [value]="infoEmpresas?.empresasInactivas?.toString() || null"
      icon="fa-solid fa-building-circle-xmark"
      tone="neutral"
    />

    <app-summary-card
      label="Empresas vencidas"
      [value]="infoEmpresas?.empresasExpiradas?.toString() || null"
      icon="fa-solid fa-building-circle-exclamation"
      tone="red"
    />

    <app-summary-card
      label="Vencen pronto"
      [value]="infoEmpresas?.empresasVencenPronto?.toString() || null"
      icon="fa-solid fa-calendar-xmark"
      tone="warning"
    />
  </div>

  <section class="data-section-card empresa-card">
    <div class="toolbar">
      <app-search-input
        class="wide-search"
        placeholder="Buscar empresa o plan..."
        [(value)]="searchInput"
        (search)="onSearch()"
      />
      <app-select
        [value]="statusFilter"
        [options]="statusOptions"
        aria-label="Filtrar por estado"
        (valueChange)="onStatusChange($event)"
      />
    </div>

    @if (mobileService.isMobile()) {
      <app-card-list
        [items]="data"
        [loading]="loadingTable"
        [emptyMessage]="'No hay empresas registradas.'"
        [showPagination]="true"
        [page]="page"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        [pageSizeOptions]="pageSizeOptions"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      >
        <ng-template #card let-empresa>
          <div class="card-list-item">
            <div class="card-list-item-header empresa-card-header">
              <strong>{{ empresa.empresa }}</strong>
              <span class="badge" [class]="getBadgeClass(empresa.estado)">
                <span class="badge-dot"> </span>
                {{ empresa.estado }}
              </span>
            </div>
            <div class="card-list-item-body">
              <div class="card-list-item-details">
                <span class="card-list-item-label"
                  >Plan:
                  <span class="card-list-item-value">
                    {{ empresa.plan }}
                  </span>
                </span>

                <span class="card-list-item-label"
                  >Usuarios:
                  <span class="card-list-item-value">
                    {{ empresa.usuarios }}
                  </span>
                </span>

                <div class="card-list-item-date-range">
                  <span class="card-list-item-label"
                    >Inicio:
                    <span class="card-list-item-value">{{
                      formatDate(empresa.fechaInicio)
                    }}</span></span
                  >
                  <span class="card-list-item-label"
                    >Fin:
                    <span class="card-list-item-value">{{
                      formatDate(empresa.fechaFin)
                    }}</span></span
                  >
                </div>
              </div>
            </div>

            <div class="card-list-item-actions empresa-card-actions">
              <app-button
                type="button"
                variant="outlined"
                size="small"
                (clicked)="editarEmpresa(empresa)"
              >
                <i class="fa-solid fa-pen-to-square"></i>
                Editar empresa
              </app-button>
              <app-button
                type="button"
                variant="outlined"
                [danger]="true"
                size="small"
                (clicked)="eliminarEmpresa(empresa)"
              >
                <i class="fa-solid fa-trash"></i>
                Eliminar
              </app-button>
            </div>
          </div>
        </ng-template>
      </app-card-list>
    } @else {
      <app-data-table-paginado
        [columns]="columns"
        [data]="data"
        [loading]="loadingTable"
        [page]="page"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        [pageSizeOptions]="pageSizeOptions"
        [showPagination]="true"
        [showPageSize]="true"
        [showActions]="true"
        [showRowHover]="true"
        [striped]="false"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (sortChange)="onSort($event)"
        (action)="onAction($event)"
      ></app-data-table-paginado>
    }
  </section>

  @if (showForm) {
    <app-modal-shell title="" [showHeader]="false" (closed)="closeForm()">
      <app-empresas-form
        [empresa]="empresaEditar"
        [planes]="planes"
        [serverError]="saveError()"
        (saved)="onEmpresaSaved($event)"
        (cancelled)="closeForm()"
      />
    </app-modal-shell>
  }

  @if (showDeleteConfirmation) {
    <app-confirmation-modal
      title="Eliminar empresa"
      [message]="deleteMessage"
      (confirmed)="confirmarEliminarEmpresa()"
      (cancelled)="cancelarEliminarEmpresa()"
      confirmLabel="Eliminar"
      cancelLabel="Cancelar"
      successTitle="Empresa eliminada"
      errorTitle="No se pudo eliminar la empresa"
      [status]="deleteStatus"
      [processing]="deletingEmpresa"
      [closeOnBackdrop]="!deletingEmpresa"
      [autoClose]="deleteStatus === 'success'"
      [iconColor]="colorIcon"
      [iconBackgroundColor]="backgroundIcon"
      (closed)="closeDeleteConfirmation()"
    />
  }
</main>
